import { svc_search, svc_addOne, svc_editOne, svc_fetchAll, svc_deleteOne } from "@/services";
import { message } from "antd";
import { showServerResponse } from "@/utils/message";
import "lodash";
import logger from "@/utils/logger";

const endpointBasePrefix = "promotions";

const Model = {
	namespace: "m_Promotions",
	state: {
		promotions: [],
		policy: [],
		scopeToken: {},
	},
	reducers: {
		handleFetchAll(state, { payload: { promotions } }) {
			logger(`** PosLanguage reducers response ${JSON.stringify(promotions)}`, 5);
			return { ...state, promotions };
		}
	},
	effects: {
		*fetchAll({ brandId, outletId, scopeToken }, { call, put }) {
			// console.log("*********************** brandId: ", brandId)
			// console.log("*********************** outletId: ", outletId)
			// console.log("Checking against scope ", scopeToken);

			let promotions = yield call(svc_search, endpointBasePrefix, { brand: brandId, outlet: outletId });
			// let promotions = yield call(svc_fetchAll, `${endpointBasePrefix}/${brandId}/${outletId}`);
			_.forEach(promotions, function (row) {

				// row.key = row.id;
				if (outletId && !scopeToken.allowedDerivedOutlets.includes(outletId)) row.disableEdit = true;
				if (brandId && !outletId && !scopeToken.allowedBrands.includes(brandId)) row.disableEdit = true;
			});
			// console.log("*********************** promotions: ", promotions)
			yield put({
				type: "handleFetchAll",
				payload: { promotions },
			});
		},
		*addOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key", "ct_isChanged", "id"]);

			// data sanitization to set empty string to null
			payload.freeQtyType = payload.freeQtyType || null;
			payload.freeValue = payload.freeValue || null;

			let response = yield call(svc_addOne, endpointBasePrefix, payload);
			logger(("Created Promotion: ", JSON.stringify(response)), 5);
			message.success("Promotion created.");
		},
		*editOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key", "ct_isChanged"]);

			// data sanitization to set empty string to null
			payload.freeQtyType = payload.freeQtyType || null;
			payload.freeValue = payload.freeValue || null;

			let response = yield call(svc_editOne, endpointBasePrefix, payload, "id");
			logger(("Edited Promotion: ", JSON.stringify(response)), 5);
			message.success("Promotion edited.");
		},
		*deleteOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key", "ct_isChanged"]);
			const response = yield call(
				svc_deleteOne,
				endpointBasePrefix,
				payload,
				"id",
				payload.key,
			);
			return showServerResponse(response);
		},
	},
	subscriptions: {
		setup({ dispatch, history }) {
			return history.listen(({ pathname, query }) => {
				if (pathname === "/promotions") {
					dispatch({ type: "fetch", payload: query });
				}
			});
		},
	},
};

export default Model;
